// extracted by mini-css-extract-plugin
export var positionBottom = "tool-tip-module--positionBottom--21332";
export var positionTop = "tool-tip-module--positionTop--a2c34";
export var root = "tool-tip-module--root--2c028";